import Requisicao from "./RequisicaoService";

class UFService {
    static async listar() {
        return Requisicao.get('endereco/uf');
    }    
}

export default UFService;